import React from "react";
import { X } from "lucide-react";
import "../AddParticipantModal.css";

interface EmailModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: () => void;
    email: string;
    setEmail: (value: string) => void;
}

export const EmailModal: React.FC<EmailModalProps> = ({
    isOpen,
    onClose,
    onSave,
    email,
    setEmail,
}) => {
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSave();
    };

    if (!isOpen) return null;

    return (
        <>
            <div
                className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50"
                onClick={onClose}
            >
                <div
                    className="relative w-full max-w-[30rem] rounded-2xl bg-white shadow-xl"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Header */}
                    <div className="flex items-center justify-between border-[#E5E7EB] py-4 px-6">
                        <h2 className="" style={{
                            color: "#0A0A0A",
                            fontFamily: "Poppins",
                            fontSize: "1.25rem",
                            fontWeight: 700,
                            lineHeight: "1.75rem"
                        }}>
                            Link Account
                        </h2>
                        {/* <button
                            onClick={onClose}
                            className="flex items-center text-[#0A0A0A] hover:text-gray-600 transition-colors"
                        >
                            <X size={20} />
                        </button> */}
                    </div>

                    {/* Content */}
                    <div className="px-6 pb-6">
                        <form onSubmit={handleSubmit}>
                            <div className="">
                                <label className="block text-base font-semibold text-[#364153] mb-2">
                                    Email Address
                                </label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter email"
                                    className="w-full px-3 py-2 border border-[#D1D5DC] rounded-[0.625rem] text-base placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:border-purple-500 focus:ring-purple-500"
                                    required
                                />
                            </div>

                            {/* Action Buttons */}
                            <div className="flex justify-end gap-3 pt-4  border-[#E5E7EB]">
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="px-6 py-2 bg-[#F3F4F6] text-[#364153] font-poppins text-base font-medium rounded-[0.625rem] hover:bg-gray-200 transition-colors"
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="px-6 py-2 bg-[#7E57C2] text-white font-poppins text-base font-medium rounded-[0.625rem] hover:bg-[#6D4CAB] transition-colors"
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};
